import { render, staticRenderFns } from "./OrdenesCompraModal.vue?vue&type=template&id=260dbd3c&"
import script from "./OrdenesCompraModal.vue?vue&type=script&lang=js&"
export * from "./OrdenesCompraModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports